module.exports = {
	"template": "light",
	"template_name": "Light Mark",
	"attributes": {
		"tagline": "Let's Find Your Dream Home",
		"facebook_url": "https://facebook.com",
		"twitter_url": "https://twitter.com",
		"instagram_url": "https://instagram.com",
		"highlight_1": "Climb Top Producer 2006-2015",
		"highlight_2": "Top 1% of San Francisco Real Estate Agents",
		"highlight_3": "Luxury Urban Living (Condos and Lofts)",
		"highlight_4": "SOMA/South Beach Resident",
		"highlight_5": "Fluent in French",
		"video_url": "https://player.vimeo.com/video/146782320?title=0",
		"quote": "An unconditional friend who loves kickboxing and is always ready for an adventure.",
		"bio": "In every profession, a group of leaders emerge that set the standards for the rest. As a former elementary school teacher, Tiffany continually raised the bar and set new standards in the teaching profession. It is with that same commitment to excellence that Tiffany has made a profound presence in the real estate community by showcasing her passion for real estate and loyalty to her clients and commitment to their real estate goals. She prides herself on open, honest and consistent communication with clients paired with the best customer relations in the industry. Her love for developing and strengthening relationships with others and impeccable follow through has continually maintained her phenomenal reputation with both clients and colleagues. Real estate relationships built on trust and the highest level of confidentiality are especially important to her.",
		"general_info_link": "https://lo.primelending.com/rwatterson",
		"general_info_1": "RON WATTERSON",
		"general_info_2": "(214) 926-9583",
		"general_info_3": "rwatterson@primelending.com",
		"general_info_4": "NMLS #184334"
	},
	"steps": [
		{
			"title": "Logo",
			"attributes": [
				{
					"key": "logo_url",
					"type": "Media",
					"title": "Logo",
					"description": "This needs to me a small square image."
				}
			]
		},
		{
			"title": "Cover Photo",
			"attributes": [
				{
					"key": "cover_image",
					"type": "Media",
					"title": "Cover photo",
					"description": "Requirement: Landscape format (more wide than tall). The cover photo is an extension of you, your brand, and your personality. Cover photo should be clean and balanced with focus on you."
				}
			]
		},
		{
			"title": "Tagline",
			"attributes": [
				{
					"key": "tagline",
					"type": "text",
					"title": "Tagline",
					"description": "Add your tagline"
				}
			]
		},
		{
			"title": "Additional Team Info",
			"attributes": [
				{
					"key": "team_info_name_1",
					"type": "text",
					"title": "Team info name 1",
					"description": "Add name 1"
				},
				{
					"key": "team_info_phone_1",
					"type": "text",
					"title": "Team info phone 1",
					"description": "Add phone 1"
				},
				{
					"key": "team_info_name_2",
					"type": "text",
					"title": "Team info name 2",
					"description": "Add name 2"
				},
				{
					"key": "team_info_phone_2",
					"type": "text",
					"title": "Team info phone 2",
					"description": "Add phone 2"
				},
				{
					"key": "team_info_name_3",
					"type": "text",
					"title": "Team info name 3",
					"description": "Add name 3"
				},
				{
					"key": "team_info_phone_3",
					"type": "text",
					"title": "Team info phone 3",
					"description": "Add phone 3"
				}
			]
		},
		{
			"title": "Social Links",
			"attributes": [
				{
					"key": "facebook_url",
					"type": "text",
					"title": "Facebook"
				},
				{
					"key": "twitter_url",
					"type": "text",
					"title": "Twitter"
				},
				{
					"key": "instagram_url",
					"type": "text",
					"title": "Instagram"
				}
			]
		},
		{
			"title": "Quick Highlights",
			"attributes": [
				{
					"key": "highlight_1",
					"type": "text",
					"title": "Highlight 1"
				},
				{
					"key": "highlight_2",
					"type": "text",
					"title": "Highlight 2"
				},
				{
					"key": "highlight_3",
					"type": "text",
					"title": "Highlight 3"
				},
				{
					"key": "highlight_4",
					"type": "text",
					"title": "Highlight 4"
				},
				{
					"key": "highlight_5",
					"type": "text",
					"title": "Highlight 5"
				}
			]
		},
		{
			"title": "Highlight Media",
			"attributes": [
				{
					"key": "highlight_image_1",
					"type": "Media",
					"title": "Highlight photo 1",
					"description": "This image shows your personality."
				},
				{
					"key": "highlight_video_1",
					"type": "VideoLink",
					"title": "Or Highlight Video 1 (YouTube or Vimeo)",
					"description": "This video shows your personality."
				},
				{
					"key": "highlight_image_2",
					"type": "Media",
					"title": "Highlight photo 2",
					"description": "This image shows more of your personality."
				},
				{
					"key": "highlight_video_2",
					"type": "VideoLink",
					"title": "Or Highlight Video 2 (YouTube or Vimeo)",
					"description": "This video shows your personality."
				}
			]
		},
		{
			"title": "Quote",
			"attributes": [
				{
					"key": "quote",
					"type": "text",
					"title": "Quote"
				}
			]
		},
		{
			"title": "About Me",
			"attributes": [
				{
					"key": "bio",
					"type": "textarea",
					"title": "Bio"
				}
			]
		},
		{
			"title": "General Info",
			"attributes": [
				{
					"key": "general_info_image",
					"type": "Media",
					"title": "General Info image",
					"description": "This can be a logo or image."
				},
				{
					"key": "general_info_link",
					"type": "text",
					"title": "General Info link",
					"description": "Image link."
				},
				{
					"key": "general_info_1",
					"type": "text",
					"title": "General Info 1"
				},
				{
					"key": "general_info_2",
					"type": "text",
					"title": "General Info 2"
				},
				{
					"key": "general_info_3",
					"type": "text",
					"title": "General Info 3"
				},
				{
					"key": "general_info_4",
					"type": "text",
					"title": "General Info 4"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/light/template.json
// module id = 454
// module chunks = 0